import type { AnalyticsEvents } from '@sunflower-games/analytics-events';
import { logCoralogix } from '@sunflower-games/coralogix-rum';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import verificationSuccessImage from '../../../assets/email-success.svg';
import Button from '../../../components/buttons/Button';
import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { analytics } from '../../../services/analytics';

import styles from './VerificationSuccess.module.scss';

export const VerificationSuccess = observer((props: WizardChildProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    const eventParams: AnalyticsEvents['email_verified_success'] = {
      event_category: 'sign_up',
      event_action: 'click',
      button_text: 'close',
    };
    void analytics.sendEvent('email_verified_success', eventParams);
    logCoralogix('email_verified_success', eventParams);
    props.nextStep();
  };

  return (
    <>
      <DialogHeader title={t('dialogs.successLowerCase')} onClose={handleClose} />

      <DialogContent>
        <p>{t('auth.emailVerifiedSuccessfully')}</p>
        <img alt="envelope" className={styles.envelope} src={verificationSuccessImage} />

        <Button btnType="main" onClick={handleClose}>
          {t('common.closeLowerCase')}
        </Button>
      </DialogContent>
    </>
  );
});
